import baseApi from "../../../common/api/baseApi";

const authHeaders = () => ({
  headers: { token: localStorage.getItem("token") }
});

/**
 * 복수권 도서 신청. BATCH_NUM 1개로 묶어 N건 INSERT 후 메일 1통 발송.
 *
 * @param {Object} payload
 * @param {Array<Object>} payload.books     도서 목록 (각 항목: bookType, ebookStore?, bookName, reqType, reqUrl, price, etc)
 * @param {string} payload.addressType      office | home | recent | etc
 * @param {string} [payload.addressEtc]     addressType==='etc' 일 때만
 */
export const purchaseRequestBatchApi = ({ books, addressType, addressEtc }) => {
  return baseApi
    .post(
      "/book/purchaseRequestBatch",
      { books, addressType, addressEtc },
      authHeaders()
    )
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
};
